import { Component, HostListener } from '@angular/core';
import { UserService } from '../user.service';
import { UIService } from '../ui.service';
import { Router } from '@angular/router';
import { BackGroundService } from './background.service';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../auth.service';
import { JwtHttpInterceptor } from '../../http/jwt.http-interceptor';
import { InitService } from '../../services/init.service';
import { PlycaErrorHandler } from '../../http/PlycaErrorHandler';
import { BaseComponent } from '../components/common/baseComponent/base.component';
import { Observable } from 'rxjs';
import { SessionInfo } from '../api/UserPrefs-dto';


@Component({
  selector: 'twofactor-auth',
  templateUrl: 'two-factorAuth.template.html'
})
export class TwoFactorAuthComponent extends BaseComponent {

  public errorMsg: string;
  public user2faCode: string;
  public show_spin = false;
  public background: any;

  constructor(private userService: UserService, private uiService: UIService, protected router: Router,
    private plycaErrorHandler: PlycaErrorHandler,
    private backGroundService: BackGroundService, private initService: InitService,
    public translateService: TranslateService, private authService: AuthService, private jwtHttpInterceptor: JwtHttpInterceptor) {

    super();
    this.background = this.calculateBackground();
  }

  public validate() {
    this.show_spin = true;
    this.subscribe(this.jwtHttpInterceptor.renewAuth(this.user2faCode),
      (sessionInfo: SessionInfo) => {
        if (sessionInfo?.user?.authenticated2FA) {
          this.initService.init();
          this.show_spin = false;
          this.router.navigate(['']);
        } else {
          this.updateInterfaceValidationError();
        }
      },
      (error: any) => {
        this.show_spin = false;
        if (error.status === 403) {
          this.updateInterfaceValidationError();
        } else {
          this.plycaErrorHandler.showServerError(error);
        }
      });
  }

  public calculateBackground() {
    return this.backGroundService.getLastBackground();
  }

  private updateInterfaceValidationError(): void {
    this.errorMsg = this.translateService.instant('TwoFactor.wrongCode');
    this.user2faCode = undefined;
  }

  @HostListener('window:beforeunload', ['$event'])
  public logout(): void {
    this.authService.logout(false);
  }


}

